import React from 'react'
import { ReactSearchAutocomplete } from 'react-search-autocomplete'


export default function AutocompleteSearch(props) {
  return (

    <ReactSearchAutocomplete
      items={props.items}
      fuseOptions={props.fuseOptions} // Search on both fields
      resultStringKeyName={props.resultString} // String to display in the results
      onSearch={props.handleOnSearch}
      onHover={props.handleOnHover}
      onSelect={props.handleOnSelect}
      onFocus={props.handleOnFocus}
      onClear={props.handleOnClear}
      showIcon={false}
      inputSearchString = {props.inputSearchString}
      placeholder= {props.placeholder}
      styling={{
        height: "34px",
        width: "31rem",
        border: "1px solid #e9e9ef",
        borderRadius: "4px",
        backgroundColor: "#f8f9fa",
        boxShadow: "none",
        hoverBackgroundColor: "#cacce7",
        color: "#000000",
        fontSize: "15px",
        // fontFamily: "Courier",
        iconColor: "#001a53",
        lineColor: "#001a53",
        placeholderColor: "#001a53",
        clearIconMargin: "0px 4px 0 0",
        zIndex: 2,
      }}
    />
  )
}

